import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoplayVideoComponent } from './autoplay-video.component';



@NgModule({
    declarations: [
        AutoplayVideoComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        AutoplayVideoComponent
    ]
})
export class AutoplayVideoModule { }
